import service from '@/utils/request';


// 生成PPT大纲
export function generateOutLine (data) {
  return service({
    url: '/v1/generatePPT/generateOutLine',
    method: 'POST',
    data: data
  })
}

// 生成PPT模版
export function generateTemplate (data) {
  return service({
    url: '/v1/generatePPT/generateTemplate',
    method: 'post',
    data
  })
}

// 请求生成PPT文档获取id
export function createPPTDocument (data) {
  return service({
    url: '/v1/generatePPT/createPPTDocument',
    method: 'post',
    data
  })
}
// 根据id获取PPT生成结果
export function getPPTResult (data) {
  return service({
    url: '/v1/generatePPT/getPPTResult',
    method: 'get',
    params: data
  })
}

// 根据id打开编辑器链接，链接有效期默认是24小时
export function pptEditorUrl (data) {
  return service({
    url: '/v1/generatePPT/pptEditorUrl',
    method: 'post',
    data: data
  })
}

// 分页获取ppt数据
export function pptHistoryList (data,) {
  return service({
    url: '/v1/generatePPT/pptHistoryList',
    method: 'get',
    params: data
  })
}

// ppt历史记录修改某个ppt名称
export function pptHistoryEdit (data) {
  return service({
    url: '/v1/generatePPT/pptHistoryEdit',
    method: 'get',
    params: data
  })
}




// ppt历史记录删除某个ppt
export function pptHistoryDelete (data) {
  return service({
    url: '/v1/generatePPT/pptHistoryDelete',
    method: 'get',
    params: data
  })
}


// 根据id下载PPT，此接口需要收钱
export function downLoadPPT (data, config = {}) {
  return service({
    url: '/v1/generatePPT/downLoadPPT',
    method: 'get',
    params: data,
    ...config
  })
}


// 下载PPT时需要判断当前用户是否有AI豆下载 true 表示可以下载 false 表示无法下载需要充值
export function downLoadPPTFlag (data) {
  return service({
    url: '/v1/generatePPT/downLoadPPTFlag',
    method: 'get',
    params: data
  })
}


// 此接口用于获取code
export function getAIPPTCode (data) {
  return service({
    url: '/v1/generateAIPPT/getAIPPTCode',
    method: 'get',
    params: data
  })
}

// 生成PPT须先调用此接口创建任务, 获取任务ID后方可进行后续生成操作
export function createPPTTask (data) {
  return service({
    url: '/v1/generateAIPPT/createPPTTask',
    method: 'POST',
    data: data
  })
}

// 此接口用于获取高级配置数据
export function getAIPPTOptions (data) {
  return service({
    url: '/v1/generateAIPPT/getAIPPTOptions',
    method: 'GET',
    data: data
  })
}

// 此接口返回第三方用户作品列表
export function getPPTList (data) {
  return service({
    url: '/v1/generateAIPPT/getPPTList',
    method: 'GET',
    params: data
  })
}


// 分页获取ppt未生成数据
export function pptDraftList (data) {
  return service({
    url: '/v1/generateAIPPT/pptDraftList',
    method: 'GET',
    params: data
  })
}


// 第三方用户修改作品名称
export function renamePPT (data) {
  return service({
    url: '/v1/generateAIPPT/renamePPT',
    method: 'post',
    data: data
  })
}


// 第三方用户删除作品
export function deletePPT (data) {
  return service({
    url: '/v1/generateAIPPT/deletePPT',
    method: 'post',
    data: data
  })
}



// ppt草稿记录回调修改
export function pptStatusCallBack (data) {
  return service({
    url: '/v1/generateAIPPT/pptStatusCallBack',
    method: 'GET',
    params: data
  })
}

// 生成PPT时需要判断当前用户是否有AI豆下载 true 表示可以下载 false 表示无法下载需要充值
export function judgeUserBuyStatus (data) {
  return service({
    url: '/v1/generateAIPPT/judgeUserBuyStatus',
    method: 'get',
  })
}

// 此接口会根据传入的参数生成一条导出任务并返回任务标识，需结合 导出结果 接口轮询返回结果。
export function exportPPt (data) {
  return service({
    url: '/v1/generateAIPPT/exportPPt',
    method: 'post',
    data: data
  })
}


// 此接口需要根据 作品导出 接口返回的任务标识轮询查询结果。
export function exportPPtResult (data) {
  return service({
    url: '/v1/generateAIPPT/exportPPtResult',
    method: 'post',
    data: data
  })
}


// 生成草稿PPT和扣费调用的接口
export function saveDraftPPT (data) {
  return service({
    url: '/v1/generateAIPPT/saveDraftPPT',
    method: 'post',
    data: data
  })
}


// 生成PPT时需要判断当前用户是否是第一次使用 true 表示是第一次使用 false 表示不是第一次使用
export function judgeUserFirstUsed (data) {
  return service({
    url: '/v1/generateAIPPT/judgeUserFirstUsed',
    method: 'get',
    params: data
  })
}



//新ppt相关接口


// 获取自定义主题列表
export function getPPTTheme (data) {
  return service({
    url: '/v1/generateAIPPT/getTheme',
    method: 'get',
    params: data
  })
}


// 获取标签选项列表
export function getTagOptions (data) {
  return service({
    url: '/v1/generateAIPPT/getTagOptions',
    method: 'get',
    params: data
  })
}


//通过url解析内容
export function getContentByUrl (data) {
  return service({
    url: '/v1/generateAIPPT/getContentByUrl',
    method: 'post',
    data: data
  })
}


// 判断是否显示公开弹窗 true表示显示 false表示不显示
export function judgePop (data) {
  return service({
    url: '/v1/generateAIPPT/judgePop',
    method: 'get',
    params: data
  })
}

// 生成同款ppt获取的参数
export function generateSamePPT (data) {
  return service({
    url: '/v1/generateAIPPT/generateSamePPT',
    method: 'get',
    params: data
  })
}


// 编辑保存PPT
export function editPPT (data) {
  return service({
    url: '/v1/generateAIPPT/editPPt',
    method: 'get',
    params: data
  })
}

//根据chatId编辑大纲内容
export function updateChat (data) {
  return service({
    url: '/v1/chat/updateChat',
    method: 'post',
    data: data
  })
}


// 编辑大纲第三方接口，保存大纲内容
export function savePPTOutLine (data) {
  return service({
    url: '/v1/generateAIPPT/savePPTOutLine',
    method: 'post',
    data: data
  })
}
